import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { ReplyIcon } from '@blade/ui-kit'
import { Button } from '@blade/ui-kit'

type CommentItemButtonReplyProps = {
  onReply: () => void
}

export const CommentItemButtonReply = ({
  onReply,
}: CommentItemButtonReplyProps) => {
  const { t } = useTranslation()

  return (
    <Root
      size="xxs"
      variant="ghost"
      iconRight={<ReplyIcon size={20} />}
      onClick={onReply}
    >
      {t('comment.message.reply')}
    </Root>
  )
}

const Root = styled(Button)`
  color: var(--text-8);
  height: 24px;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  padding-inline: 10px;

  svg {
    width: 16px;
  }
`
